import { render, staticRenderFns } from "./InsertCategory.vue?vue&type=template&id=55fff08b"
import script from "./InsertCategory.vue?vue&type=script&lang=js"
export * from "./InsertCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports